import { connect } from 'react-redux'

import AdminSettingsComponent from '../components/AdminSettingsComponent'
import { refreshTaxes, refreshPayments } from 'redux/modules/settings'
import { showModal } from 'redux/modules/modals'
const mapActionCreators = {
  showModal,
  refreshTaxes,
  refreshPayments
}

const mapStateToProps = state => {
  return {
    settings: state.settings
  }
}

export default connect(mapStateToProps, mapActionCreators)(
  AdminSettingsComponent
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Settings/containers/AdminSettingsContainer.js